import { Typography } from 'antd'
import React from 'react'
import { TitleProps } from 'antd/es/typography/Title'

export function Title({ children }: TitleProps) {
    return <Typography.Title level={2}>{children}</Typography.Title>
}
